/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VCDSOrgTypesEnum = 'VCDS_INTERNAL_ENGINEERING' | 'VCDS_EXTERNAL_POC' | 'VCDS_INTERNAL_CUSTOMER' | 'VCDS_EXTERNAL_CUSTOMER' | 'VCDS_UNKNOWN' | 'VCDS_INTERNAL_DEV_QA' | 'VCDS_EXTERNAL_TRIAL' | 'VCDS_EXTERNAL_MANAGED';

export const VCDSOrgTypesEnum = {

    VCDS_INTERNAL_ENGINEERING: 'VCDS_INTERNAL_ENGINEERING' as VCDSOrgTypesEnum,

    VCDS_EXTERNAL_POC: 'VCDS_EXTERNAL_POC' as VCDSOrgTypesEnum,

    VCDS_INTERNAL_CUSTOMER: 'VCDS_INTERNAL_CUSTOMER' as VCDSOrgTypesEnum,

    VCDS_EXTERNAL_CUSTOMER: 'VCDS_EXTERNAL_CUSTOMER' as VCDSOrgTypesEnum,

    VCDS_UNKNOWN: 'VCDS_UNKNOWN' as VCDSOrgTypesEnum,

    VCDS_INTERNAL_DEV_QA: 'VCDS_INTERNAL_DEV_QA' as VCDSOrgTypesEnum,

    VCDS_EXTERNAL_TRIAL: 'VCDS_EXTERNAL_TRIAL' as VCDSOrgTypesEnum,

    VCDS_EXTERNAL_MANAGED: 'VCDS_EXTERNAL_MANAGED' as VCDSOrgTypesEnum
};

